import { ChoiceState } from "../state/reducers/choiceReducer";
import { Choice, ID } from "../types";

export interface GroupedChoices {
  [key: ID]: Choice[];
}

const groupChoicesByPageId = (choices: ChoiceState) => {
  return choices.allIds.reduce<GroupedChoices>((acc, choiceId) => {
    const choice = choices.byId[choiceId];
    if (!choice) return { ...acc };
    const pageId = choice.pageId;
    return { ...acc, [pageId]: [...(acc[pageId] || []), choice] };
  }, {});
};

export default groupChoicesByPageId;
